import { render, staticRenderFns } from "./AuctionRoutes.vue?vue&type=template&id=f38f0062"
import script from "./AuctionRoutes.vue?vue&type=script&lang=js"
export * from "./AuctionRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports